export const FEEDBACK_HISTORY_TABLE = 'feedbackTable';

export const FeedbackSummaryFields = {
  LATEST_IMPORTANT_FEEDBACK: 'Latest important feedback',
  CALL_HISTORY: 'Call history',
  EMIS_PAID: "EMI's paid",
  LOAN_AMOUNT: 'Loan amount',
  PTP_PER_EMI: 'PTP Per Emi'
};

export const NO_FEEDBACK_HISTORY_TEXT = 'No feedback recorded';
export const NO_ESCALATION_RECORD_COPY = 'No escalation recorded';

export const RepaymentHistoryFields = {
  CURRENT_DUE_DETAILS: 'Current due details'
};

export const DUE_PAID_STATUS = {
  EARLY: 'Early',
  ON_TIME: 'On-time',
  LATE: 'Late'
} as { [key: string]: string };

export const CALL_SOURCE_LIMIT = 2;
